import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventTypes } from 'src/app/core/enums/event.enum';
import { DocumentService } from 'src/app/core/services/common/document.service';
import { EnrollmentExtendedService } from 'src/app/core/services/onboarding/enrollment-extended.service';
import { PageStateService } from 'src/app/core/services/onboarding/page-state.service';

@Component({
  selector: 'app-msa-dashboard',
  templateUrl: './msa-dashboard.component.html',
  styleUrls: ['./msa-dashboard.component.scss'],
})
export class MsaDashboardComponent implements OnInit {
  subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private ps: PageStateService,
    private ds: DocumentService,
    private ees: EnrollmentExtendedService
  ) {}

  async ngOnInit() {
    this.subscriptions.push(
      this.route.data.subscribe(async (data) => {
        this.subscriptions.push(
          this.route.queryParams.subscribe((params) => {
            const { transitions } = data['data'];
            const fpPageState = this.ps.getPageStateByEventAndTransitions(
              EventTypes.FINANCIAL_PROFILE,
              transitions
            );
            this.ees.updateOnlyFinancialProfileStateId(fpPageState.id);
          })
        );
      })
    );
  }

  async clickEvent(): Promise<boolean> {
    const url = await this.ds.getMsaUrl();
    window.open(url, '_blank');
    return false;
  }
}
